import { c as _c } from "react/compiler-runtime";
import { getCurrencyKey, readCurrencyFragment } from "@opensea/app-kit";
import { FlexColumn, List, TextBody, withSuspense } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { useIsAbstractWalletAccount } from "../../../hooks/useIsAbstractWalletAccount";
import { useTopCurrencies } from "../../../hooks/useTopCurrencies";
import { CurrencyItem } from "../CurrencyItem";
import { CurrencySkeletons } from "./CurrencySkeletons";
function TopCurrenciesComponent(t0) {
  const $ = _c(25);
  const {
    selectedChain,
    onSelectCurrency,
    fetching: fetchingProp,
    removeSwapDisabledCurrencies,
    searchCurrencies
  } = t0;
  const t = useTranslations("wallet.TopCurrencies");
  const isAbstractWallet = useIsAbstractWalletAccount();
  let t1;
  if ($[0] !== selectedChain) {
    t1 = selectedChain === "all" ? undefined : [selectedChain];
    $[0] = selectedChain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let chains = t1;
  if (isAbstractWallet) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = ["abstract"];
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    chains = t2;
  }
  const t2 = removeSwapDisabledCurrencies ? true : null;
  let t3;
  if ($[3] !== chains || $[4] !== t2) {
    t3 = {
      chains,
      swappable: t2
    };
    $[3] = chains;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      by: "ONE_DAY_VOLUME",
      direction: "DESC"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = {
      filter: t3,
      sort: t4
    };
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    currencies: currenciesData,
    fetching: fetchingTopCurrencies
  } = useTopCurrencies(t5);
  let t6;
  if ($[9] !== currenciesData) {
    t6 = currenciesData.map(_temp);
    $[9] = currenciesData;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const currencies = t6;
  const filteredCurrencies = searchCurrencies || currencies;
  const fetching = fetchingProp || fetchingTopCurrencies;
  let t7;
  if ($[11] !== t) {
    t7 = t("trendingTokens");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <TextBody>{t7}</TextBody>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== fetching || $[16] !== filteredCurrencies || $[17] !== onSelectCurrency || $[18] !== t) {
    t9 = fetching ? <CurrencySkeletons /> : filteredCurrencies.length === 0 ? <TextBody className="mx-2 pb-5">{t("noCurrenciesFound")}</TextBody> : filteredCurrencies.map(currency_0 => <CurrencyItem currency={currency_0} key={getCurrencyKey(currency_0)} onClick={() => onSelectCurrency(currency_0)} />);
    $[15] = fetching;
    $[16] = filteredCurrencies;
    $[17] = onSelectCurrency;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <List className="-mx-2 bg-transparent" showBorder={false}>{t9}</List>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <FlexColumn className="gap-2.5">{t8}{t10}</FlexColumn>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(currency) {
  return readCurrencyFragment(currency);
}
function TopCurrenciesSkeleton() {
  const $ = _c(7);
  const t = useTranslations("wallet.TopCurrencies");
  let t0;
  if ($[0] !== t) {
    t0 = t("trendingTokens");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <List className="-mx-2 bg-transparent" showBorder={false}><CurrencySkeletons /></List>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <FlexColumn className="gap-2.5">{t1}{t2}</FlexColumn>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export const TopCurrencies = withSuspense(TopCurrenciesComponent, <TopCurrenciesSkeleton />);